export const hotTags = [
  '今晚到底站谁',
  '新剧争议结局',
  '顶流机场照',
  '综艺剪辑风波',
  '演唱会黄牛',
  '年度红毯造型',
];

export interface PollTopic {
  id: number;
  rank: number;
  title: string;
  heat: number;
  tag: string;
  tagColor: string;
  optionA: string;
  optionB: string;
  votesA: number;
  votesB: number;
}

export const trendingPolls: PollTopic[] = [
  {
    id: 1,
    rank: 1,
    title: '年度热剧大结局官宣方式，你更吃哪一套？',
    heat: 98600,
    tag: '影视热榜',
    tagColor: 'primary',
    optionA: '官博卡点卡到大结局',
    optionB: '主演直播一起看剧',
    votesA: 18420,
    votesB: 21650,
  },
  {
    id: 2,
    rank: 2,
    title: '综艺剪辑「吵翻天」后，节目组应不应该道歉？',
    heat: 87300,
    tag: '综艺现场',
    tagColor: 'accent',
    optionA: '该，粉丝被遛麻了',
    optionB: '吵出热度就别卖惨',
    votesA: 20510,
    votesB: 9610,
  },
  {
    id: 3,
    rank: 3,
    title: '演唱会座位分区涨价，合理吗？',
    heat: 64200,
    tag: '演出市场',
    tagColor: 'secondary',
    optionA: '合理，山顶党也能接受',
    optionB: '不合理，纯割粉丝',
    votesA: 8230,
    votesB: 16940,
  },
  {
    id: 4,
    rank: 4,
    title: '明星机场营业照，你喜欢「精修大片」还是「随手生图」？',
    heat: 53700,
    tag: '时尚造型',
    tagColor: 'accent',
    optionA: '生图最真实',
    optionB: '大片才有排面',
    votesA: 13210,
    votesB: 7630,
  },
  {
    id: 5,
    rank: 5,
    title: '新一季选秀规则大改，你看好谁夺冠？',
    heat: 41100,
    tag: '偶像圈',
    tagColor: 'primary',
    optionA: '全能实力派',
    optionB: '人气黑马',
    votesA: 12050,
    votesB: 10820,
  },
];

export interface Category {
  name: string;
  desc: string;
  count: string;
  icon: string;
  tone: string;
}

export const categories: Category[] = [
  { name: '明星八卦', desc: '追星冲浪，蹲最新动态', count: '2.1k 条瓜', icon: 'ri-sparkling-2-fill', tone: 'primary' },
  { name: '影视剧综', desc: '新剧新综艺第一手讨论', count: '1.8k 条瓜', icon: 'ri-movie-2-fill', tone: 'accent' },
  { name: '演出票房', desc: '演唱会音乐节红黑榜', count: '960 条瓜', icon: 'ri-mic-fill', tone: 'secondary' },
  { name: '时尚红毯', desc: '造型比拼与穿搭风向', count: '780 条瓜', icon: 'ri-shirt-fill', tone: 'primary' },
  { name: '品牌商业', desc: '代言翻车与商业动向', count: '640 条瓜', icon: 'ri-store-3-fill', tone: 'accent' },
  { name: '社会热议', desc: '全网都在吃的那口瓜', count: '1.2k 条瓜', icon: 'ri-chat-3-fill', tone: 'secondary' },
];

export interface FeedItem {
  id: number;
  tag: string;
  tagTone: string;
  title: string;
  summary: string;
  reads: string;
  comments: string;
  hot: boolean;
  img: string;
  imgAlt: string;
}

export const freshFeed: FeedItem[] = [
  {
    id: 1,
    tag: '影视热榜',
    tagTone: 'primary',
    title: '新剧大结局上线三小时冲上热搜，观众吵疯了',
    summary: '收官夜官微卡点放出双结局彩蛋，两派观众在评论区互不相让，播放平台服务器一度告急。',
    reads: '86w',
    comments: '4.2k',
    hot: true,
    img: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20drama%20poster%20moodboard%20with%20film%20clapperboard%20and%20popcorn%2C%20cream%20and%20coral%20tones%2C%20soft%20studio%20light%2C%20stylized%20editorial%20illustration%2C%20modern%20minimal&width=1200&height=760&seq=fresh-01&orientation=landscape',
    imgAlt: '新剧大结局热度海报与放映元素',
  },
  {
    id: 2,
    tag: '综艺现场',
    tagTone: 'accent',
    title: '这档综艺又上热搜：剪辑争议后再添新瓜',
    summary: '上一秒还在为赛制吵，下一秒导师彩排视频流出，节目组回应「尊重每一位选手」。',
    reads: '54w',
    comments: '3.1k',
    hot: false,
    img: 'https://readdy.ai/api/search-image?query=Studio%20set%20with%20stage%20lights%20and%20microphone%20booms%2C%20warm%20orange%20and%20cream%20palette%2C%20stylized%20variety%20show%20illustration%2C%20soft%20glow%2C%20modern%20editorial&width=1200&height=760&seq=fresh-02&orientation=landscape',
    imgAlt: '综艺录制现场灯光舞台元素',
  },
  {
    id: 3,
    tag: '演出票房',
    tagTone: 'secondary',
    title: '演唱会门票秒罄之后，二手市场又要「溢价起飞」？',
    summary: '官宣三分钟售罄，闲鱼同款却贵了三倍。主办方发声明打击黄牛，粉丝却在「抢票玄学」里互相抱团。',
    reads: '42w',
    comments: '2.8k',
    hot: true,
    img: 'https://readdy.ai/api/search-image?query=Concert%20crowd%20silhouette%20with%20neon%20stage%20glow%20and%20ticket%2C%20warm%20gold%20and%20deep%20brown%20palette%2C%20stylized%20illustration%2C%20energetic%20minimal%20composition&width=1200&height=760&seq=fresh-03&orientation=landscape',
    imgAlt: '演唱会人群与门票元素',
  },
  {
    id: 4,
    tag: '时尚造型',
    tagTone: 'primary',
    title: '红毯造型出炉：有人封神，有人被嘲「年度灾难」',
    summary: '造型师连夜上线带货同款，粉丝盘点历届红毯「神图」与「翻车名场面」，你心中的最佳是谁？',
    reads: '31w',
    comments: '1.9k',
    hot: false,
    img: 'https://readdy.ai/api/search-image?query=Red%20carpet%20glamour%20with%20evening%20gown%20and%20camera%20flashes%2C%20warm%20rose%20and%20cream%20tones%2C%20stylized%20editorial%20fashion%20illustration%2C%20soft%20light%2C%20elegant%20minimal&width=1200&height=760&seq=fresh-04&orientation=landscape',
    imgAlt: '红毯礼服与闪光灯氛围元素',
  },
  {
    id: 5,
    tag: '品牌商业',
    tagTone: 'accent',
    title: '代言塌房后品牌连夜解约，网友：这波公关打几分？',
    summary: '从官宣到解约只用了十八小时，品牌方声明被扒出「连夜改稿」，评论区上演教科书级公关吐槽大会。',
    reads: '27w',
    comments: '1.6k',
    hot: false,
    img: 'https://readdy.ai/api/search-image?query=Broken%20megaphone%20with%20contract%20documents%20and%20storefront%2C%20warm%20amber%20and%20cream%20palette%2C%20stylized%20business%20news%20illustration%2C%20minimal%20clean%20composition&width=1200&height=760&seq=fresh-05&orientation=landscape',
    imgAlt: '解约声明与品牌商业元素',
  },
  {
    id: 6,
    tag: '偶像圈',
    tagTone: 'secondary',
    title: '顶流生日应援卷出新高度，粉丝却说「这届最克制」',
    summary: '没有地铁广告也没有无人机，今年的应援转向公益与阅读角。粉丝：把爱落到实处，才配得上「长情」二字。',
    reads: '22w',
    comments: '1.2k',
    hot: false,
    img: 'https://readdy.ai/api/search-image?query=Warm%20birthday%20celebration%20with%20book%20and%20small%20plants%20donation%20theme%2C%20soft%20olive%20and%20cream%20palette%2C%20stylized%20illustration%2C%20gentle%20minimal%20composition&width=1200&height=760&seq=fresh-06&orientation=landscape',
    imgAlt: '应援公益与阅读元素',
  },
];

export interface ReaderPost {
  id: number;
  badge: string;
  title: string;
  text: string;
  likes: string;
  comments: string;
  time: string;
  author: string;
  verified: boolean;
}

export const readerPosts: ReaderPost[] = [
  {
    id: 1,
    badge: '精选来稿',
    title: '作为现场观众，我想说节目组真没故意剪「撕」',
    text: '录制那晚气氛其实很友好，争议画面是被拼接过度的。别被节奏带跑，理性吃瓜，等完整版播出再站队也不迟。',
    likes: '3.2k',
    comments: '860',
    time: '今天 14:20',
    author: '前排瓜子@小鹿',
    verified: true,
  },
  {
    id: 2,
    badge: '本周置顶',
    title: '扒完历年红毯造型，我发现「神图」都是有公式的',
    text: '配色干净、裁剪合身、发型点睛，再加一个「此刻恰到好处」的瞬间。收藏这份穿搭公式，你也可以轻松看懂红毯。',
    likes: '5.1k',
    comments: '1.4k',
    time: '昨天 21:05',
    author: '时尚显微镜@阿禾',
    verified: true,
  },
  {
    id: 3,
    badge: '新晋来稿',
    title: '黄牛报价截图流出，演唱会抢票到底难在哪',
    text: '本人连坐三次「已售罄」，实测秒杀软件反而更快。来料仅供参考：蹲回流票、认准官方渠道，别让荷包变韭菜。',
    likes: '2.7k',
    comments: '720',
    time: '昨天 09:40',
    author: '冲票战士@一颗海盐',
    verified: false,
  },
];

export const hotComments = [
  { text: '终于有人说实话了，这波我站理性吃瓜！', tag: '前排瓜子', name: '夜宵配瓜' },
  { text: '蹲一个完整版，先不急着开喷，都冷静冷静。', tag: '理性观众', name: '不站队吃瓜' },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: '吃瓜日报的热榜投票是怎么玩的？',
    a: '每天我们会精选当天的热议话题发起双选项投票，你点选自己支持的一方即可参与，票数会实时累加，并展示两个阵营的支持占比与当前热度。',
  },
  {
    q: '怎么在吃瓜日报投稿爆料？',
    a: '点击页面中的「投稿爆料」按钮，在投稿表单里依次填写你的称呼、联系方式、来料类型和具体内容并提交即可。稿件审核通过后，有机会在「粉丝来稿」与今日头条中展示，并同步生成结构化页面供站内检索。',
  },
  {
    q: '投稿需要实名吗？可以匿名吗？',
    a: '不需要实名。你可以选择匿名或使用昵称署名，我们仅保留用于联系与核对稿件的邮箱等基础信息，并对投稿人的真实身份严格保密。',
  },
  {
    q: '私信内容会不会被公开？',
    a: '默认不会。只有在你明确授权、且内容经过核实与脱敏处理后，才可能用于公开报道；其余私信与来料内容一律保密，绝不对外公开。',
  },
  {
    q: '吃瓜日报的内容从哪里来？可信吗？',
    a: '内容主要来自编辑团队对公开信息的梳理，以及粉丝的投稿来料。凡是涉及传闻与单方说法的地方，我们都会明确标注「网传待核实」，引导大家理性吃瓜，不传播未经证实的结论。',
  },
];

export const faqsSeo = faqs;